import script from "./Timer.vue?vue&type=script&setup=true&lang=js"
export * from "./Timer.vue?vue&type=script&setup=true&lang=js"

import "./Timer.vue?vue&type=style&index=0&id=22a9cc28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a9cc28"]])

export default __exports__